import React from 'react';
import GalleryMenu from '../../../../atoms/GalleryMenu';
import MediaPlayIcon from '../../../../atoms/icons/MediaPlayIcon';
import { Photo, PhotoStatusTitle, PhotoStatus, PrivateTotal, VideoInProgress, MediaPlayWrap } from './GalleryStyles';
import VideoGalleryMenu from '../../../../atoms/VideoGalleryMenu';
import VideoGear from '../../../../icons/VIdeoGear';

interface PrivateGalleryProps {
  url: any;
  status: any;
  isProfile: any;
  openLightbox: any;
  index: any;
  photoKey: any;
  makeDefault: any;
  isPrivate: any;
  photoId: any;
  isAvatar: any;
  mediaType: any;
  hasBulkSelection: any;
}

const PrivateGallery = ({
  url,
  status,
  isProfile,
  openLightbox,
  index,
  photoKey,
  makeDefault,
  isPrivate,
  photoId,
  isAvatar,
  mediaType,
  hasBulkSelection,
}: PrivateGalleryProps): any => {
  const isPending = status === 'new';
  const isCenterAlign = !isProfile && !isPending;
  const isVideo = mediaType === 'video';

  return (
    <PrivateTotal>
      {isVideo && status === 'pending' ? (
        <VideoInProgress>
          <VideoGear />
          <div style={{ margin: '10px auto', width: '80%' }}>Video Processing...</div>
        </VideoInProgress>
      ) : (
        <Photo
          data-test-id="private-img-monkey"
          imgUrl={url}
          onClick={e => {
            e.preventDefault();
            openLightbox(index, e);
          }}
        />
      )}

      {isVideo && status !== 'pending' && (
        <MediaPlayWrap>
          <MediaPlayIcon
            onClick={e => {
              e.preventDefault();
              openLightbox(index, e);
            }}
          />
        </MediaPlayWrap>
      )}

      <PhotoStatus isCenterAlign={isCenterAlign}>
        {isProfile && isAvatar && isPending && <PhotoStatusTitle>Pending {mediaType}</PhotoStatusTitle>}

        {isVideo ? (
          <VideoGalleryMenu
            key={photoKey}
            theKey={photoKey}
            isPrivate={isPrivate}
            mediaId={photoId}
            isPending={isPending}
            isCenterAlign={isCenterAlign}
            hasBulkSelection={hasBulkSelection}
          />
        ) : (
          <GalleryMenu
            key={photoKey}
            theKey={photoKey}
            makeDefault={makeDefault}
            isPrivate={isPrivate}
            photoId={photoId}
            isAvatar={isAvatar}
            isPending={isPending}
            isCenterAlign={isCenterAlign}
            hasBulkSelection={hasBulkSelection}
          />
        )}
        {isProfile && isAvatar && <PhotoStatusTitle>Profile</PhotoStatusTitle>}
        {!(isProfile && isAvatar) && isPending && <PhotoStatusTitle>Pending</PhotoStatusTitle>}
      </PhotoStatus>
    </PrivateTotal>
  );
};

export default PrivateGallery;
